exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".adder-card[data-v-4279a5de]{padding:0;border-radius:9px;-webkit-box-shadow:0 3px 10px 4px rgba(0,106,255,.08),0 2px 2px 0 rgba(0,83,199,.09),0 1px 5px 0 rgba(0,83,199,.09);box-shadow:0 3px 10px 4px rgba(0,106,255,.08),0 2px 2px 0 rgba(0,83,199,.09),0 1px 5px 0 rgba(0,83,199,.09)}.card-preview[data-v-4279a5de]{height:300px}", ""]);

// exports
